import {Component, Input}   from '@angular/core';
import {Block}              from "../../block";
import {Author}             from "../../../models/generic";
import {PageComponentModel} from "../../../models/page";
import {TranslateService}   from "@ngx-translate/core";

@Component({
    selector   : 'app-author',
    templateUrl: './author.component.html',
})
export class AuthorComponent extends Block {
    @Input() page: PageComponentModel | null = null;

    constructor(
        private readonly translateService: TranslateService,
    ) {
        super();
    }

    get author(): Author | undefined {
        return this.page?.author ?? undefined;
    }

    get authorLabel(): string {
        return this.translateService.currentLang === 'en' ? 'Author' : 'Auteur';
    }
}
